"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _HeaderText = require("@ccw-pwa-ui/HeaderText");
require("../styles/DispatcherStoreDashboard.css");
const StoreDashBoardFirstVisitComponent = _ref => {
  let {
    headerText,
    string
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "dispatcherStore-body"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "dispatcherStore-headingdiv"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    variant: "header-text",
    headerText: headerText
  })), string.MAIN_CONTENT.$$typeof ? string.MAIN_CONTENT : /*#__PURE__*/_react.default.createElement("div", {
    className: "disStore-content"
  }, string.MAIN_CONTENT.toString()), /*#__PURE__*/_react.default.createElement("div", {
    className: "disStore-subContent"
  }, string.SUB_CONTENT), string.BOTTOM_CONTENT.$$typeof ? string.BOTTOM_CONTENT : /*#__PURE__*/_react.default.createElement("div", {
    className: "disStore-bottomContent"
  }, string.BOTTOM_CONTENT.toString()));
};
var _default = exports.default = StoreDashBoardFirstVisitComponent;